import settings from '@/settings'

let getAll = (headers, filtros, page) => {
  let url = `${settings.apetrusApi}/convenio/listartodos/`
  if (page) filtros['page'] = page
  if (filtros) {
    Object.keys(filtros).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${filtros[filter]}`
    })
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let editarConvenio = (headers, payload) => {
  let url = `${settings.apetrusApi}/convenio/`
  return fetch(url, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(payload),
    headers: headers
  })
}

let ativarOuDesativar = (headers, id) => {
  return fetch(`${settings.apetrusApi}/convenio/ativaroudesativar/${id}/`, {
      method: 'PUT',
      mode: 'cors',
      headers: headers
  })
}

export default {
  getAll,
  editarConvenio,
  ativarOuDesativar
}
